// A horse, modelled facing +X: a long chestnut body on tall legs, an arched
// neck, a maned head and a flowing tail. Ported 1:1 from age-of-mcp's classic
// horse.ts, restoring its leg loop + body/neck/head/mane/tail composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.075, 0.03], [0.075, -0.03], [-0.075, 0.03], [-0.075, -0.03]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.135, 4),
      color: "#5a3a20", position: [x!, 0.0675, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#8a5328",
      position: [0, 0.135, 0], scale: [1.9, 1, 0.85] },               // body
    { geometry: new THREE.CylinderGeometry(0.022, 0.03, 0.085, 5), color: "#8a5328",
      position: [0.11, 0.165, 0], rotation: [0, 0, -0.7] },           // neck
    { geometry: new THREE.BoxGeometry(0.055, 0.03, 0.028), color: "#94592c",
      position: [0.15, 0.2, 0] },                                      // head
    { geometry: new THREE.ConeGeometry(0.008, 0.018, 4), color: "#6a4220",
      position: [0.13, 0.225, 0.012] },                              // ear
    { geometry: new THREE.ConeGeometry(0.008, 0.018, 4), color: "#6a4220",
      position: [0.13, 0.225, -0.012] },
    { geometry: new THREE.BoxGeometry(0.012, 0.07, 0.04), color: "#3a2412",
      position: [0.09, 0.18, 0], rotation: [0, 0, -0.6] },           // mane
    { geometry: new THREE.CylinderGeometry(0.006, 0.018, 0.09, 4), color: "#3a2412",
      position: [-0.115, 0.1, 0], rotation: [0, 0, 0.5] },           // tail
  );
  return parts;
}

export const horse = defineModel({
  id: "horse",
  scale: 2.75, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Horse",
  tags: ["creature","horse","low-poly","age-of-mcp","classic"],
  summary: "Low-poly horse.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.16,
  fits: ["draft"],
  parts: () => partsFor(),
  animations: [],
});
